import {useCallback, useMemo} from "react";
import {useMutation, useQuery} from "@apollo/client";
import {addOrganizationLibraryIBeaconUuidMutation, getOrganizationsQuery} from "./areaQueries";

export const useOrganizationLibrary = (organizationId: string | undefined) => {
    const {data} = useQuery(getOrganizationsQuery, {
        variables: {organizationIds: organizationId ? [organizationId] : []},
        skip: !organizationId,
        fetchPolicy: "cache-and-network",
    });
    const [addUuidMutation] = useMutation(addOrganizationLibraryIBeaconUuidMutation, {
        refetchQueries: [
            {
                query: getOrganizationsQuery,
                variables: {organizationIds: organizationId ? [organizationId] : []},
            },
        ],
        awaitRefetchQueries: true,
    });

    const iBeaconUuids: string[] = useMemo(() => {
        const orgs = (data as any)?.getOrganizations || [];
        const match = orgs.find((org: any) => org?.id === organizationId);
        const uuids = match?.library?.iBeaconUuids;
        return Array.isArray(uuids) ? uuids : [];
    }, [data, organizationId]);

    const addIBeaconUuid = useCallback(async (uuid: string) => {
        if (!organizationId || !uuid) {
            return;
        }
        try {
            await addUuidMutation({
                variables: {organizationId: organizationId, uuid: uuid},
            });
        } catch (error) {
            console.warn("[organizationLibrary] failed to save iBeacon UUID", error);
        }
    }, [addUuidMutation, organizationId]);

    return {
        iBeaconUuids,
        addIBeaconUuid,
    };
};
